import axios from 'axios';
import config from '@/config';
import { getToken, logOut } from '@/auth/auth';

const axiosInstance = axios.create({ baseURL: config.apiURL });

axiosInstance.interceptors.request.use(async request => {
  const authToken = await getToken();
  if (!authToken) {
    logOut();
    throw 'Invalid auth token.';
  }

  request.headers.Authorization = `Bearer ${authToken}`;
  return request;
});

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    if (!error.response || error.response.status !== 401) throw error.response;

    // In the ideal world, the Amplify lib would take care of token refresh itself
    // In the current implementation this will just result in null anyways
    const authToken = await getToken();
    if (authToken) axiosInstance.request(error.config);
    // to login page
    logOut();
  }
);

export default axiosInstance;
